module.exports = __webpack_public_path__ + "static/media/redo.65cafe30.svg";